import { formatCurrency } from "@ashirbad/js-core";
import { Avatar, Button } from "@mui/material";
import { useIsMounted } from "hooks";
import { useOrdersData } from "hooks/useDataFetch";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

const InvoiceGenerate = () => {
  const [orderDetails, setOrderDetails] = useState();
  const isMounted = useIsMounted();
  const { id } = useParams();
  const orders = useOrdersData();
  useEffect(() => {
    if (isMounted.current) {
      if (!orders?.data) return;

      let data = orders?.data?.find((item) => {
        return item?.id === id;
      });

      setOrderDetails(data || {});
    }
  }, [isMounted, orders?.data, id]);
  // console.log(orderDetails);

  const printToPdf = useReactToPrint({
    content: () => document.getElementById("invoice-print"),
  });

  return (
    <section className="invoice-generate" id="invoice-print">
      <div className="invoice-generate-title">
        <h4>Invoice ID - {id}</h4>
      </div>
      <div className="invoice-container">
        <div className="flex-row w-100 justify-content-between align-items-center ">
          <div className="flex-row gap-2 invoice-address ">
            <span className="flex-column gap-1">
              <h3>From</h3>
              <h4>Water Project</h4>
              <h4>Riyad ,Saudi Arab</h4>
              <h4>waterproject.email.com</h4>
              <h4>+123456789077</h4>
            </span>
            <span className="flex-column gap-1">
              <h3>To</h3>
              <h4>
                {" "}
                {orderDetails?.address?.firstName +
                  " " +
                  orderDetails?.address?.lastName}
              </h4>
              <h4>
                {orderDetails?.address?.address +
                  " ," +
                  orderDetails?.address?.city +
                  " " +
                  orderDetails?.address?.landmark +
                  " " +
                  orderDetails?.address?.postalCode}{" "}
              </h4>
              <h4> {orderDetails?.address?.contactNo} </h4>
              <h4> {orderDetails?.address?.country} </h4>
            </span>
          </div>
          <div className="flex-column gap-1 invoice-address ">
            <h3>Details</h3>
            <h4>Invoice Id : {id}</h4>
            <h4>
              Date : {moment(orderDetails?.deliveredAt).format("DD-MM-YYYY")}
            </h4>
          </div>
        </div>
      </div>
      <div className="w-100">
        <table className="order-details-table w-100">
          <thead className="w-100 order-table-head">
            <tr className="flex-row align-items-center  gap-2 w-100">
              <th>#</th>
              <th>Image</th>
              <th>Product</th>
              <th>Supplier</th>
              <th>Quantity/Uint</th>
              <th>Price</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody className="order-details-table-body">
            {orderDetails?.products?.map((item, index) => {
              return (
                <tr
                  className="flex-row align-items-center  gap-2 w-100"
                  key={index}
                >
                  <td>{index + 1}</td>
                  <td>
                    <Avatar
                      src={item?.productImg}
                      sx={{
                        width: "6rem",
                        height: "7rem",
                        borderRadius: "10px",
                      }}
                    />
                  </td>
                  <td>{item?.productName}</td>
                  <td>{item?.supplierName}</td>
                  <td>{item?.orderedQty}</td>
                  <td>{formatCurrency(item?.price, "SAR")}</td>
                  <td>
                    {formatCurrency(item?.price * item?.orderedQty, "SAR")}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="flex-row align-items-center order-table-foot  gap-2 w-100">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>
                {formatCurrency(
                  orderDetails?.products?.reduce(
                    (acc, item) => acc + item?.price * item?.orderedQty,
                    0
                  ),
                  "SAR"
                )}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="w-100 invoice-footer flex-row justify-content-center">
        <Button
          sx={{
            backgroundColor: "#1851c2 !important",
            color: "white",
            ":hover": {
              backgroundColor: "#1851c2 !important",
              color: "white",
            },
          }}
          onClick={printToPdf}
        >
          Print PDF
        </Button>
      </div>
      <div className="w-100 invoice-footer flex-row justify-content-center">
        Thank you for your purchase @Water Project
      </div>
    </section>
  );
};

export default InvoiceGenerate;
